import React, { useEffect, useState } from 'react';
import { db } from './firebase'; 
import { collection, addDoc, serverTimestamp, query, where, getDocs } from "firebase/firestore";

const TYPEWRITER_LINES = ["A world of dreams and adventures", "with PokéBubble awaits!"];
const TYPEWRITER_TEXT = TYPEWRITER_LINES.join("\n");

const App = () => {
  const [visible, setVisible] = useState(false);
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle');
  const [typedText, setTypedText] = useState('');
  const [typingDone, setTypingDone] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 100);
    if (localStorage.getItem('pokebubble_joined')) {
      setStatus('success');
    }
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    if (!visible) return;
    let i = 0;
    const interval = setInterval(() => {
      i++;
      setTypedText(TYPEWRITER_TEXT.slice(0, i));
      if (i >= TYPEWRITER_TEXT.length) {
        clearInterval(interval);
        setTypingDone(true);
      }
    }, 55);
    return () => clearInterval(interval);
  }, [visible]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setStatus('loading');
    try {
      const q = query(collection(db, "waitlist"), where("email", "==", email.toLowerCase()));
      const querySnapshot = await getDocs(q);
      if (querySnapshot.empty) {
        await addDoc(collection(db, "waitlist"), {
          email: email.toLowerCase(),
          joinedAt: serverTimestamp(),
        });
      }
      localStorage.setItem('pokebubble_joined', 'true');
      setStatus('success');
    } catch (error) {
      console.error("Error:", error);
      setStatus('error');
    }
  };

  return (
    <div style={{
      height: '100vh', 
      width: '100vw',
      backgroundColor: '#0f172a',
      display: 'flex', 
      flexDirection: 'column',
      alignItems: 'center', 
      justifyContent: 'center',
      fontFamily: 'system-ui, sans-serif', 
      color: 'white',
      overflow: 'hidden',
      position: 'relative'
    }}>
      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Press+Start+2P&display=swap');
          input::placeholder {
            color: #94a3b8;
            opacity: 0.5;
          }
          input:focus {
            border-color: #3b82f6 !important;
          }
          .gradient-text {
            background: linear-gradient(135deg, #22d3ee, #3b82f6);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            font-weight: 600;
          }
          .typewriter-cursor {
            display: inline-block;
            width: 8px;
            height: 1em;
            background: #22d3ee;
            margin-left: 3px;
            vertical-align: text-bottom;
            animation: blink 0.8s step-end infinite;
          }
        `}
      </style>
      
      <div style={{
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : 'translateY(10px)',
        transition: 'all 0.8s ease-out', 
        textAlign: 'center',
        width: '100%',
        maxWidth: '400px',
        padding: '0 20px',
        marginTop: '-40px'
      }}>
        
        {/* Centered Logo Section */}
        <div style={{ position: 'relative', marginBottom: '16px' }}>
          <div style={{ position: 'relative', display: 'inline-block' }}>
            <img 
              src="/pb_logo_wtext.png" 
              alt="Pokebubble" 
              style={{ height: "140px", width: 'auto', filter: 'brightness(0) invert(1)', display: 'block' }} 
            />
            <div style={{
              position: 'absolute', inset: 0,
              background: 'linear-gradient(135deg, #22d3ee, #3b82f6)',
              WebkitMaskImage: 'url(/pb_logo_wtext.png)', WebkitMaskSize: '100% 100%',
              maskImage: 'url(/pb_logo_wtext.png)', maskSize: '100% 100%',
            }} />
          </div>
        </div>

        {/* Typewriter Text */}
        <div style={{
          fontFamily: "'Press Start 2P', monospace",
          fontSize: '0.6rem',
          color: 'rgba(148, 163, 184, 0.5)',
          lineHeight: '1.8',
          marginBottom: '24px',
          minHeight: '3.6em',
        }}>
          {typedText.split('\n').map((line, i) => (
            <div key={i}>{line}</div>
          ))}
        </div>

        {/* Content Section */}
        <div>
          {status === 'success' ? (
            <div style={{ 
              padding: '20px', 
              borderRadius: '16px', 
              border: '2px solid transparent',
              backgroundImage: 'linear-gradient(#0f172a, #0f172a), linear-gradient(135deg, #22d3ee, #3b82f6)',
              backgroundOrigin: 'border-box',
              backgroundClip: 'padding-box, border-box',
              boxShadow: '0 0 20px rgba(34, 211, 238, 0.15)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px'
            }}>
              <span>✨</span>
              <span className="gradient-text" style={{ fontSize: '1rem' }}>
                You're on the list! We'll reach out soon.
              </span>
            </div>
          ) : (
            <>
              <form onSubmit={handleSubmit} style={{ display: 'flex', gap: '8px', flexDirection: 'column' }}>
                <input
                  type="email" 
                  placeholder="Enter your email" 
                  required
                  disabled={status === 'loading'}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  style={{
                    padding: '14px 16px', borderRadius: '10px',
                    border: '1px solid #334155', backgroundColor: '#1e293b',
                    color: 'white', outline: 'none', fontSize: '1rem',
                    transition: 'border-color 0.2s'
                  }}
                />
                <button
                  type="submit"
                  disabled={status === 'loading'}
                  style={{
                    padding: '14px', borderRadius: '10px', border: 'none',
                    background: 'linear-gradient(135deg, #22d3ee, #3b82f6)',
                    color: '#0f172a', fontWeight: '700', cursor: 'pointer',
                    fontSize: '0.85rem'
                  }}
                >
                  {status === 'loading' ? '...' : 'Join the waitlist for early Beta access'}
                </button>
              </form>
            </>
          )}
        </div>
      </div>

      {/* Footer */}
      <footer style={{
        position: 'absolute',
        bottom: '24px',
        fontSize: '0.75rem',
        color: '#475569',
        letterSpacing: '0.05em'
      }}>
        © 2026 PokéBubble
      </footer>
    </div>
  );
};

export default App;